import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { AuthPageWrapper, AuthPageTitle } from 'features/auth';
import { AuthPageLink } from 'types';

import { CreatePasswordForm, TermsAndConditions } from '../../components';

type LocationState = {
  is_email_exist?: string;
};
export function FinishUserActivationPage(): ReactElement {
  const { t } = useTranslation();
  const styles = { padding: '85px 96px 0 96px' };
  const { state } = useLocation();

  const isEmailExist = (state as LocationState)?.is_email_exist === 'true';

  return (
    <AuthPageWrapper link={AuthPageLink.signIn} contentSx={styles}>
      <AuthPageTitle>
        {isEmailExist ? t('activateEmployee.formTitle') : t('activateEmployee.pageTitle')}
      </AuthPageTitle>

      <CreatePasswordForm isEmailExist={isEmailExist} />
      <TermsAndConditions />
    </AuthPageWrapper>
  );
}
